import { render, staticRenderFns } from "./ProjectFilesCard.vue?vue&type=template&id=24d119ef&scoped=true"
import script from "./ProjectFilesCard.vue?vue&type=script&lang=js"
export * from "./ProjectFilesCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectFilesCard.vue?vue&type=style&index=0&id=24d119ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d119ef",
  null
  
)

export default component.exports